/**
 * Tailwind CSS breakpoints.
 * md = 768px, lg = 1024px
 */
export const BREAKPOINTS = {
  md: 768,
  lg: 1024,
} as const;

/**
 * Calculate slides per view based on viewport width.
 * Mobile (<768): 1, Tablet (768-1023): 2, Desktop (>=1024): configured value
 */
export function calculateSlidesPerView(viewportWidth: number, configuredSlidesPerView: number): number {
  if (viewportWidth < BREAKPOINTS.md) return 1;
  if (viewportWidth < BREAKPOINTS.lg) return 2;
  return configuredSlidesPerView;
}
